var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWechatSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.192
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,32.17a21.33,21.33,0,0,1-5.81-.71,2.63,2.63,0,0,0-1.45.24c-1.35.76-2.64,1.62-4.17,2.58.28-1.27.46-2.38.78-3.45a1.31,1.31,0,0,0-.6-1.74c-4.65-3.28-6.61-8.2-5.14-13.26,1.36-4.68,4.69-7.51,9.22-9a15.47,15.47,0,0,1,16.89,4.94,15.09,15.09,0,0,1,2.71,7.55m-18.13-3a1.79,1.79,0,0,0-1.72-1.78,1.73,1.73,0,0,0-1.81,1.68A1.71,1.71,0,0,0,12.47,18,1.76,1.76,0,0,0,14.3,16.32Zm9.3-1.78a1.79,1.79,0,0,0-1.75,1.76,1.75,1.75,0,0,0,1.8,1.7,1.73,1.73,0,1,0,0-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.83,42.05c-1.22-.54-2.35-1.36-3.55-1.49s-2.45.57-3.69.69a12.36,12.36,0,0,1-10-3.27C18.22,33,19,25.46,25.17,21.41c5.49-3.6,13.55-2.4,17.42,2.6a9.88,9.88,0,0,1-1.14,13.8c-1.19,1.06-1.62,1.94-.86,3.33a4,4,0,0,1,.24.91Zm-14-13.52a1.44,1.44,0,1,0,0-2.88,1.44,1.44,0,1,0,0,2.88Zm9-2.88A1.43,1.43,0,0,0,34.44,27a1.42,1.42,0,1,0,2.84.12A1.43,1.43,0,0,0,35.87,25.65Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechatSvgrepoCom);
export default __webpack_public_path__ + "static/media/wechat-svgrepo-com.59d859ddfb23c17560eecf61860e8be9.svg";
export { ForwardRef as ReactComponent };